export enum ScannerCameraStatus {
  IDLE = 'idle',
  INITIALIZING = 'initializing',
  READY = 'ready',
  OPENING = 'opening',
  OPEN = 'open',
  PAUSED = 'paused',
  PERMISSION_DENIED = 'permission-denied',
  CAMERA_NOT_FOUND = 'camera-not-found',
  CAMERA_BUSY = 'camera-busy',
  ERROR = 'error'
}
